import React from "react";

const Disclaimer = () => {
  return (
    <div className="container-fluid py-5" style={{ marginTop: "110px" }}>
      <div className="row justify-content-center">
        <div className="col-lg-10">

          <div
            className="card border-0 rounded-4 p-4 p-md-5"
            style={{ fontSize: "16px", lineHeight: "1.8" }}
          >
            {/* Title */}
            <h1
              className="text-center mb-4 fw-bold"
              style={{ color: "#cc9051" }}
            >
              Disclaimer
            </h1>

            <p>
              Welcome to <strong>tulikaarts.in</strong>. By accessing and browsing this website, you
              agree to the following terms and conditions.
            </p>

            {/* Limitation of Liability */}
            <h4 className="fw-bold mt-4">Limitation of Liability</h4>
            <ul className="list-group list-group-flush mb-3">
              <li className="list-group-item">Use or reliance on website information.</li>
              <li className="list-group-item">Errors or omissions in website content.</li>
              <li className="list-group-item">
                Unauthorized use or reproduction of artwork images.
              </li>
              <li className="list-group-item">Technical issues or website downtime.</li>
            </ul>

            {/* Copyright */}
            <h4 className="fw-bold">Copyright & Intellectual Property</h4>
            <p>
              All artwork images, designs, and content on this website are copyrighted and owned
              by <strong>tulikaarts.in</strong> and/or its respective artists. Unauthorized reproduction,
              distribution, or use is strictly prohibited.
            </p>

            {/* Color Variations */}
            <h4 className="fw-bold">Color Variations</h4>
            <p>
              Due to screen resolution differences, the actual colors of artwork may vary from how
              they appear on the website.
            </p>

            {/* Pricing */}
            <h4 className="fw-bold">Artwork Availability & Pricing</h4>
            <p>All artwork availability and pricing are subject to change without notice.</p>

            {/* User Content */}
            <h4 className="fw-bold">User-Generated Content</h4>
            <p>
              By submitting feedback, comments, or artwork to this website, you grant
              <strong> tulikaarts.in </strong> a non-exclusive, royalty-free right to display and use such
              content.
            </p>

            {/* Third-party Links */}
            <h4 className="fw-bold">Third-Party Links</h4>
            <p>
              This website may contain links to external websites. <strong>tulikaarts.in</strong> is not
              responsible for the content, accuracy, or policies of any external sites.
            </p>

            {/* Changes */}
            <h4 className="fw-bold">Changes to Disclaimer</h4>
            <p>
              We may update or modify this disclaimer at any time without prior notice.
            </p>

            {/* Contact */}
            <h4 className="fw-bold">Contact</h4>
            <p>
              For questions or concerns regarding this disclaimer, contact us at:
            </p>

            <p className="mb-1">
              📧 Email:
              <a href="mailto:tulikartsworks@gmail.com" className="ms-1">
                tulikartsworks@gmail.com
              </a>
            </p>

            <p>
              📞 Phone:
              <a href="tel:+91986926077" className="ms-1">
                +91 9869261077
              </a>
            </p>

          </div>

        </div>
      </div>
    </div>
  );
};

export default Disclaimer;
